import $ from 'jquery';

export function initLinkingVars(form, data) {
    Object.keys(form.sections).forEach(function (key, index) {
        form.sections[key].variables.forEach(function (variable) {
            if (variable.link !== undefined) {
                if (data[variable.config][variable.name] !== undefined) {
                    new LinkVar(variable, data[variable.config][variable.name]);
                }
            }
        });
    });
}

class LinkVar {
    constructor(private configVar, private configValue) {
        this.bind();
    }
    
    private bind() {
        const linkWithSelector = $('[name="config[' + this.configVar.config + '][' + this.configVar.name + ']"]');
        const selector = $('[name="config[' + this.configVar.link.with.configName + '][' + this.configVar.link.with.varName + ']"]');
        
        if (linkWithSelector.length > 0) {
            linkWithSelector.on('change', (event) => {
                let value = $(event.target).val() as string;
                selector.empty();
                
                if (this.configVar.link.data[value] !== undefined) {
                    this.configVar.link.data[value].forEach((item) => {
                        let option = new Option(item[1], item[0]);
                        selector.append($(option));
                    });

                    selector.closest('[data-search-value]').fadeIn();
                } else {
                    selector.closest('[data-search-value]').fadeOut();
                }
            });
        }
    
        linkWithSelector.find('option').each((index, element) => {
            if (this.configValue === $(element).val()) {
                linkWithSelector.trigger('change');
            }
        });
    }
}
